import logoIcon from '../assets/logo-icon.png'
import wordmark from '../assets/wordmark.png'
import wordmarkDark from '../assets/wordmark-dark.png'

interface FactoryLogoProps {
  className?: string
}

export function FactoryLogo({ className = 'w-8 h-8' }: FactoryLogoProps) {
  return <img src={logoIcon} alt="Factory Nexus" className={className} />
}

export function FactoryWordmark({ className = 'h-5' }: FactoryLogoProps) {
  return (
    <>
      <img src={wordmark} alt="Factory Nexus" className={`${className} w-auto dark:hidden`} />
      <img src={wordmarkDark} alt="Factory Nexus" className={`${className} w-auto hidden dark:block`} />
    </>
  )
}
